import { Space } from '../../Hooks/useRecommendation/useSpaceRecommendations'
import VenueSearchCard from './VenueSearchCard'
import { SparklesIcon } from '../UI/Icons'
import { motion } from 'framer-motion'

export interface SpaceInterest {
  spaceId: number
  hostId: number
}

interface Props {
  recommendations: Space[]
  filteredRecommendations: Space[]
  defaultRecommendations?: Space[]
  page: number
  onLoadMore: () => void
  requestedSpaces: SpaceInterest[]
  onToggleSpace: (spaceId: number, hostId: number) => void
  onCardClick?: (spaceId: number) => void
}

const VenueList = ({
  recommendations,
  filteredRecommendations,
  defaultRecommendations = [],
  page,
  onLoadMore,
  requestedSpaces,
  onToggleSpace,
  onCardClick,
}: Props) => {
  const fallbackToDefaults =
    filteredRecommendations.length === 0 && defaultRecommendations.length > 0
  const venuesToRender = fallbackToDefaults ? defaultRecommendations : filteredRecommendations

  return (
    <>
      {fallbackToDefaults && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.35, ease: 'easeOut' }}
          className='bg-[rgba(175,35,28,0.05)] rounded-lg p-2 flex flex-col gap-4 mb-4'>
          <div className='flex items-center gap-2'>
            <SparklesIcon />
            <p className='text-base text-black'>
              {recommendations.length === 0
                ? 'No exact matches browse all venues that matched your brief in the area or adjust your prompt.'
                : 'No exact matches browse all venues that matched your brief in the area or adjust your venue name.'}
            </p>
          </div>
        </motion.div>
      )}
      <div className='flex flex-col gap-4'>
        {venuesToRender.slice(0, page * 6).map((space) => {
          const spaceId = Number(space.id)
          const isSelected = requestedSpaces.some((s) => s.spaceId === spaceId)
          return (
            <VenueSearchCard
              key={space.id}
              space={space}
              isSelected={isSelected}
              onToggle={() => onToggleSpace(spaceId, space.hostID)}
              onCardClick={onCardClick ? () => onCardClick(spaceId) : undefined}
            />
          )
        })}
      </div>
      <div className='flex justify-center items-center pt-4'>
        {page * 6 < venuesToRender.length && (
          <button className='hb-button button-small secondary-button' onClick={onLoadMore}>
            + Load more
          </button>
        )}
      </div>
    </>
  )
}

export default VenueList
